// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"591":"personal","728":"usuarios","913":"default"}[chunkId] || chunkId) + "-legacy." + {"386":"cfb32f1c","591":"9f3c6d86","728":"2363cb84","913":"6025c79f"}[chunkId] + ".js";
};